import { trackEvent, isSupportedAction } from "@/composables/useMetrics";

const FALLBACK_ACTION = "info_click";

/**
 * Tracks ally-related events using the shared metrics service.
 * Falls back to the generic action when a custom action is not supported.
 * @param {string|number} allyId
 * @param {string} action
 * @param {Record<string, unknown>} metadata
 */
export const trackAllyEvent = async (allyId, action, metadata = {}) => {
  if (!allyId) {
    console.warn("trackAllyEvent requires a valid allyId");
    return;
  }

  const augmentedMeta = { ...metadata };

  if (isSupportedAction(action)) {
    await trackEvent("ally", allyId, action, augmentedMeta);
    return;
  }

  await trackEvent("ally", allyId, FALLBACK_ACTION, {
    alias_action: action,
    ...augmentedMeta,
  });
};

export default {
  trackAllyEvent,
};
